import { render } from "./badge.md?vue&type=template&id=7ce958cb"
import script from "./badge.md?vue&type=script&lang=js"
export * from "./badge.md?vue&type=script&lang=js"
script.render = render

export default script